import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";

// Define TypeScript types
interface Option {
  id: number;
  name: string;
}

interface MultiSelectDropdownProps {
  data: Option[];
  selectedNames: Option[];
  placeHolder?: string;
  disable?: boolean;
  setSelectedNames: React.Dispatch<React.SetStateAction<Option[]>>;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  data,
  selectedNames,
  setSelectedNames,
  placeHolder = "Select Options",
  disable = false,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  // Handle Selection
  const handleSelect = (item: Option) => {
    setSelectedNames((prevSelected) => {
      const alreadySelected = prevSelected.some((i) => i.id === item.id);
      return alreadySelected
        ? prevSelected.filter((i) => i.id !== item.id) // Remove if already selected
        : [...prevSelected, item]; // Add new selection
    });
  };

  // Handle Chip Removal
  const handleRemoveChip = (id: number) => {
    setSelectedNames(selectedNames.filter((chip) => chip.id !== id));
  };

  return (
    <div style={{ width: "100%" }}>
      {/* Selected Items as Chips */}
      {selectedNames.length > 0 && (
        <div
          style={{
            //   display: "flex",
            //   flexWrap: "wrap",
            //   gap: "5px",
            //   padding: "5px",
            //   border: "1px solid #d9d9d9",
            //   borderRadius: "5px",
            //   minHeight: "40px",
            //   alignItems: "center",
            //   cursor: "pointer",
            //   backgroundColor:"red",
            //   width: "100%"
            color: "#767676",

            border: "1px solid #EDEDED",
            borderRadius: "8px",
            padding: "5px",
            fontSize: "13px",
            width: "100%",
            textAlign: "left",
            boxShadow: "none",
            fontWeight: "400",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "5px",
            minHeight: "40px",
          }}
          // onClick={toggleDropdown}
        >
          {selectedNames?.map((item) => (
            <Badge
              key={item.id}
              color="primary"
              pill
              style={{
                cursor: disable ? "default" : "pointer",
                padding: "6px 10px",
                fontSize: 11,
              }}
              onClick={disable ? undefined : () => handleRemoveChip(item.id)}
            >
              {item.name} ✖
            </Badge>
          ))}
        </div>
      )}

      {/* Dropdown */}
      {!disable && (
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle
            color=""
            style={{
              color: "#767676",
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "11px",
              fontSize: "13px",
              width: "100%",
              textAlign: "left",
              boxShadow: "none",
              fontWeight: "400",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: selectedNames?.length > 0 ? "10px" : "0px",
            }}
          >
            {placeHolder}
          </DropdownToggle>
          <DropdownMenu
            className="dropdown-block"
            style={{
              width: "100%",
              borderRadius: "8px",
              border: "1px solid #EDEDED",
              padding: "5px 0",
              maxHeight: "200px",
              overflowY: "scroll",
            }}
          >
            {data.map((item) => (
              <DropdownItem
                key={item.id}
                style={{
                backgroundColor:"transparent",
                  padding: "10px 15px",
                  fontSize: "14px",
                  // color: "#333",
                  cursor: "pointer",
                }}
                onClick={() => handleSelect(item)}
                active={selectedNames.some((i) => i.id === item.id)}
              >
                {item.name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
